import { STUDIO_API_BASE_URL_V5 } from '../config';

export const ScheduleAPIRoutes = {
  createNewSchedule: () => `${STUDIO_API_BASE_URL_V5}/create_schedule`,
  updateSchedule: () => `${STUDIO_API_BASE_URL_V5}/update_schedule`,
  deleteSchedule: () => `${STUDIO_API_BASE_URL_V5}/delete_schedule`,
};
